import { message } from 'antd'
import { deleteRamsSigning } from '../../../HttpRequests/ramsSignings'
import { getProps } from '../props'
import handleException from '../../../Core/Helpers/handleException'

export default () => async () => {

  const { id, onClose, didDelete } = getProps()

  try {

    await deleteRamsSigning({ id })

    message.success('RamsSigning Deleted')

    onClose()

    if (didDelete) didDelete()

  } catch (error) {

    handleException(error)

  }

}
